import { render, staticRenderFns } from "./DocumentSignatures.vue?vue&type=template&id=2f406d3e&scoped=true"
import script from "./DocumentSignatures.vue?vue&type=script&lang=js"
export * from "./DocumentSignatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f406d3e",
  null
  
)

export default component.exports